import { Toolbar } from "@planningcenter/topbar"
import { bool, string } from "prop-types"

const RegistrationsToolbar = ({
  appName,
  railsEnv,
  userAvatarPath,
  userName,
  isPhoenix = false
}) => {
  return (
    <Toolbar
      appName={appName}
      env={railsEnv}
      userAvatarPath={userAvatarPath}
      userName={userName}
      isPhoenix={isPhoenix}
    />
  )
}

RegistrationsToolbar.propTypes = {
  appName: string.isRequired,
  railsEnv: string.isRequired,
  userAvatarPath: string.isRequired,
  userName: string.isRequired,
  isPhoenix: bool
}

export default RegistrationsToolbar
